import { COLORS } from '../constants/theme';
import { TERMS_PAGE_2, TERMS_PAGE_3 } from '../constants/terms';
import { renderInlineParagraph } from '../utils/textRenderer';

export const drawTerms = (engine) => {
    const doc = engine.getDoc();
    const pageManager = engine.getPageManager();

    // Add page for Terms & Conditions and draw background card
    pageManager.addPage({ drawTermsCard: true, resetYTo: 50 });

    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(13);
    doc.setTextColor(...COLORS.TEXT_DARK_GRAY);
    doc.text("KINDERLAND", 306, 52, { align: 'center' });

    doc.setFontSize(10);
    doc.setTextColor(...COLORS.TEXT_MEDIUM_GRAY);
    doc.text("TERMS AND CONDITIONS OF WHOLESALE AND DISTRIBUTOR TRANSACTIONS", 306, 67, { align: 'center' });

    doc.setDrawColor(...COLORS.BORDER_TERMS_CARD);
    doc.line(40, 77, 572, 77);

    const allTerms = [...TERMS_PAGE_2, ...TERMS_PAGE_3];
    let termsY = 92;
    const maxWidth = 522;
    const fontSize = 8.5;

    allTerms.forEach(clause => {
        // Estimate height of this clause
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(fontSize);
        const prefix = clause.title.trim() + ". ";
        const titleWidth = doc.getTextWidth(prefix);

        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(fontSize);

        const paragraphs = clause.text.split('\n');
        const firstPara = paragraphs[0] || "";
        const words = firstPara.split(/\s+/);
        let currentLine = "";
        let wordIndex = 0;
        const firstLineMax = maxWidth - titleWidth;

        while (wordIndex < words.length) {
            const testLine = currentLine ? currentLine + " " + words[wordIndex] : words[wordIndex];
            if (doc.getTextWidth(testLine) > firstLineMax) {
                break;
            }
            currentLine = testLine;
            wordIndex++;
        }

        let lineCount = 1;
        const restOfFirstPara = words.slice(wordIndex).join(" ");
        if (restOfFirstPara) {
            const splitLines = doc.splitTextToSize(restOfFirstPara, maxWidth);
            lineCount += splitLines.length;
        }

        for (let i = 1; i < paragraphs.length; i++) {
            const para = paragraphs[i].trim();
            if (para) {
                const splitLines = doc.splitTextToSize(para, maxWidth);
                lineCount += splitLines.length;
            }
        }

        const estimatedHeight = lineCount * 10 + (paragraphs.length - 1) * 4;

        // Check page overflow (limit = 740 to leave bottom padding)
        if (termsY + estimatedHeight > 740) {
            pageManager.addPage({ drawTermsCard: true, resetYTo: 50 });
            termsY = 50;
        }

        // Render the clause
        termsY = renderInlineParagraph(doc, clause.title, clause.text, 45, termsY, maxWidth, fontSize);
        termsY += 12; // gap between clauses
    });

    engine.getCursor().setY(termsY);
    return termsY;
};
